export default "__VITE_ASSET__BUeNGMcq__"